// @owner ClientPlatform

import type {FC} from 'react';
import React, {useEffect} from 'react';
import Cookies from 'js-cookie';
import {AuthCard} from '../../../signin/components/authCard/authCard';
import {returnValidRedirectUrl, userDidSignIn} from '../../../helpers/signupHelpers';

function redirectToApp() {
  const ssoBaseUrl = `${location.protocol}//${location.host}`;
  const redirectUrl = returnValidRedirectUrl(Cookies.get('front.redirect_to') || '');
  Cookies.remove('front.redirect_to');
  userDidSignIn(redirectUrl, ssoBaseUrl);
}

interface SsoRedirectProps {
  /* Injectable so Storybook can render the page without performing a redirect. */
  onMount?: () => void;
}

export const SsoRedirect: FC<SsoRedirectProps> = ({onMount = redirectToApp}) => {
  useEffect(() => {
    onMount();
  }, [onMount]);

  return (
    <AuthCard>
      <p>Sign in successful. You are being redirected to the app.</p>
    </AuthCard>
  );
};
